export const handleTaxIDType = ({name, value, setValues, setTaxIdSelected}) => {
  if (name === "taxIDType") {
    if (value === null || value === undefined) {
      return setValues((values) => ({ ...values, taxID: "" }));
    }
    setTaxIdSelected(value);
  }
};
